export const getCellFormat = (type?: string, dateFormat?: string) => {
  if (type === 'date') {
    return dateFormat;
  }
  if (type === 'currency') {
    return '£#,##0.00';
  }
  return undefined;
};
